// frontend/src/utils/permissions.js
// Mirror of the backend permission check. Used to show/hide Dashboard sections.
// Supports "*" (all) and "<section>:*" (whole section) wildcards.

export function hasPermission(userPermissions, required) {
  if (!userPermissions || !required) return false;
  const set = userPermissions instanceof Set ? userPermissions : new Set(userPermissions);

  if (set.has('*')) return true;
  if (set.has(required)) return true;

  const section = required.split(':')[0];
  if (set.has(`${section}:*`)) return true;

  return false;
}
